module.exports = [
    {
        date: "",
        text: [],
    },
    {
        date: "1998",
        text: ["中国科学院自动化研究所率先展开国内虹膜识别研究"],
    },
    {
        date: "2005",
        text: ["虹膜图像获取与识别技术荣获国家技术发明奖二等奖"],
    },
    {
        date: "2008",
        text: ["荣获国际虹膜识别竞赛 NICE I 第一名"],
    },
    {
        date: "2010",
        text: ["研发出工作距离达3米的国内首台远距离虹膜识别系统"],
    },
    {
        date: "2013",
        text: ["率先基于计算成像技术进行多目标虹膜人脸系统研发"],
    },
    {
        date: "2015",
        text: ["天津中科智能产业技术研究院成立，同时设立生物特征识别事业部"],
    },
    {
        date: "2016",
        text: ["远距离虹膜人脸融合识别系统量产并获得场景应用"],
    },
    {
        date: "2017",
        text: ["中科虹星成立——中国科学院重大科研成果产业化"],
    },
    {
        date: "2018",
        text: [
            "中科虹星人工智能研发总部正式落户于北京中关村",
            "中科虹星华南地区运营中心及计算成像模组厂正式落户于深圳",
            "在美国国家标准与技术研究院（NIST）的第9次虹膜识别技术测试中取得优异成绩",
            "中科虹星牵头制定国家公共安全虹膜图像质量标准",
            "中科虹星新疆办事处在乌鲁木齐成立",
            "远距离虹膜识别技术入选科技日报“2018年国内十大技术突破”，并获得中国科学报头版头条报道",
        ],
    },
    {
        date: "2019",
        text: [
            "W200和S300-UC获批公安虹膜采集建库专用设备",
            "公安部副部长参观远距离虹膜识别产品",
            "成立中科虹星山东分公司",
            "加入信息技术应用创新工作委员会",
        ],
    },
    {
        date: "2020",
        text: [
            "软硬件产品全部实现国产化",
            "主导参与4项生物特征识别（虹膜）国家标准",
            "提出“实时场景智能化”概念，开始数字化转型",
            "公司产品在多场景落地应用",
            "成立北京中科虹星智能科技有限公司",
        ],
    },
    {
        date: "2021",
        text: [],
    },
];
